import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c8b64e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading text-center mb20" }, "デイリートレーニングレポート", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("日付指定で検索")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "sub-heading-mt" }, "トレーニング別実施状況", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "sub-heading-mt" }, "個別実施状況", -1))

import { useStore } from "vuex";
import { computed, onMounted, ref } from 'vue'
import { Chart, ChartData, ChartOptions, registerables } from "chart.js";
import { BarChart } from "vue-chart-3";
import { DailyLearningLogic } from "@/logic/learning/DailyLearningLogic";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

Chart.register(...registerables);
const { dailyLearningReports, getReport, dailyLearningUserReports, getUserReport, dailyLearningLoading } = DailyLearningLogic();
const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);
onMounted(async (): Promise<void> => {
  getReport()
  getUserReport()
});
const barData: ChartData<'bar'> = computed(() => {
  const label_array: string[] = []
  const values: number[] = []
  const rate_values: number[] = []
  for (const result of dailyLearningReports.value) {
    label_array.push(result.date)
    values.push(result.do_count)
    rate_values.push(result.correct_rate)
  }
  return {
    labels: label_array,
    datasets: [
      {
        type: 'bar',
        label: "実施数",
        data: values,
        borderColor: "rgb(234, 82, 66, 0.7)",
        backgroundColor: "rgb(234, 82, 66, 0.7)",
        yAxisID: "yaxes_1",
        order: 2,
      },
      {
        type: 'line',
        label: "正解率",
        data: rate_values,
        borderColor: "rgb(44, 154, 122, 0.7)",
        backgroundColor: "rgb(44, 154, 122, 0.7)",
        yAxisID: "yaxes_2",
        order: 1,
        gridLines: { // このオプションを追加
          drawOnChartArea: false,
        },
      },
    ],
  }
});
const options = computed<ChartOptions<'bar'>>(() => ({
  responsive: true,
  scales: {
    yaxes_1: {
      id: "y-axis-1",
      type: "linear",
      position: "left",
      // ticks: {
      //   max: 0.2,
      //   min: 0,
      //   stepSize: 0.1
      // },
    },
    yaxes_2: {
      type: "linear",
      position: "right",
      ticks: {
        max: 100,
        min: 0,
        stepSize: 10
      },
    },
  },
  plugins: {
    legend: {
      align: 'end',
    },
  }
}));
const daterange = ref<Date[]>([]);
// const daterange = ref<string[]>([]);
const disabledDate = (time: Date) => {
  // nowDate = Date.now()
  let beforeTwoMonth = new Date
  beforeTwoMonth.setMonth(beforeTwoMonth.getMonth() - 2)
  if (time.getTime() < beforeTwoMonth.getTime()) {
    return true;
  }
  return time.getTime() > Date.now()
}
const rangeSearch = () => {
  if (daterange.value && daterange.value[0] && daterange.value[1]) {
    getReport({ start_date: daterange.value[0].toString(), end_date: daterange.value[1].toString() });
    getUserReport({ start_date: daterange.value[0].toString(), end_date: daterange.value[1].toString() });
  } else {
    getReport();
    getUserReport();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { class: "box-card" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_el_date_picker, {
                    modelValue: daterange.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((daterange).value = $event)),
                    type: "daterange",
                    "range-separator": "〜",
                    "start-placeholder": "開始日",
                    "end-placeholder": "終了日",
                    "value-format": "YYYY-MM-DD",
                    "disabled-date": disabledDate
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: rangeSearch,
                    class: "align"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_unref(BarChart), {
                      chartData: _unref(barData),
                      options: _unref(options)
                    }, null, 8, ["chartData", "options"])
                  ], 512), [
                    [_directive_loading, _unref(dailyLearningLoading)]
                  ]),
                  _hoisted_3,
                  _createVNode(_component_el_table, {
                    data: _unref(dailyLearningReports),
                    size: "small",
                    stripe: "",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "date",
                        label: "日付",
                        width: "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "do_count",
                        label: "実施数",
                        width: "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "correct_rate",
                        label: "正解率(%)"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "answer_time_avg",
                        label: "解答平均タイム(秒)"
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _hoisted_4,
                  _createVNode(_component_el_table, {
                    data: _unref(dailyLearningUserReports),
                    size: "small",
                    stripe: "",
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "name",
                        label: "名前",
                        width: "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "join_at",
                        label: "プロジェクト参加日",
                        width: "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "do_count",
                        label: "実施数",
                        width: "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "correct_rate",
                        label: "正解率(%)"
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})